module.exports = __webpack_public_path__ + "static/media/use_graph02_eng.b524a93a.jpg";